import vuetify from "../../plugins/vuetify"

export default {
  setUserData (state, user) {
    if (user.hasOwnProperty('id')) state.id = user.id
    if (user.hasOwnProperty('firstName')) state.firstName = user.firstName
    if (user.hasOwnProperty('lastName')) state.lastName = user.lastName
    if (user.hasOwnProperty('email')) state.email = user.email
    if (user.hasOwnProperty('phone')) state.phone = user.phone
    if (user.hasOwnProperty('ext')) state.ext = user.ext
    if (user.hasOwnProperty('title')) state.title = user.title
    if (user.hasOwnProperty('disabled')) state.disabled = user.disabled
    if (user.hasOwnProperty('resetFlag')) state.resetFlag = user.resetFlag
    if (user.hasOwnProperty('role')) state.role = user.role
    if (user.hasOwnProperty('created_at')) state.created_at = user.created_at
    if (user.hasOwnProperty('updated_at')) state.updated_at = user.updated_at
    if (user.hasOwnProperty('photo')) state.photo = user.photo
    if (user.hasOwnProperty('customer_id')) state.customer_id = user.customer_id
    if (user.hasOwnProperty('customer_name')) state.customer_name = user.customer_name
    if (user.hasOwnProperty('abilities')) state.abilities = user.abilities
    if (user.hasOwnProperty('seen_notification')) state.seen_notification = user.seen_notification
  },
  setUserPhoto (state, photo) {
    state.photo = photo
  },
  setUserAbilities (state, abilities) {
    state.abilities = abilities
  },
  clear (state) {
    state.id = null
    state.firstName = ''
    state.lastName = ''
    state.email = ''
    state.phone = ''
    state.ext = ''
    state.title = ''
    state.disabled = null
    state.resetFlag = null
    state.hasProfileImage = null
    state.role = ''
    state.created_at = null
    state.updated_at = null
    state.photo = null
    state.customer_id = null
    state.customer_name = ''
    state.abilities = []
  },
  setJustLoggedIn(state, value) {
    state.justLoggedIn = value;
  }
}
